var getJSON = function(url, callback) {
	var xhr = new XMLHttpRequest();
	xhr.open('GET', url, true);
	xhr.responseType = 'json';
	xhr.onload = function() {
		var status = xhr.status;
		if (status === 200) {
			callback(null, xhr.response);
		} else {
			callback(status, xhr.response);
		}
	};
	xhr.send();
};

var SHEET_JSON_URL = 'https://sheets.googleapis.com/v4/spreadsheets/1dGxDsx2B_1R95aXVR9xOmdUBLMpxLP57fvE3ol_oWl0/values/Aktuality?alt=json&key=AIzaSyCPtK6MTtpNi_qsYglhn_fKkEOuc6KZixU';

getJSON(SHEET_JSON_URL,
	function(err, data) {
		if (err !== null) {
			console.log('Nepodařilo se stáhnout data ohledně aktualit: ' + err);
		} else {
			if (typeof data == 'string') {
				data = JSON.parse(data);
			}

			if (data.values && data.values.length > 1) {
				var output = '';

				for (var itemIndex = 1; itemIndex <= data.values.length; itemIndex++) {
					if (data.values[itemIndex]) {
						output += '<div>' + data.values[itemIndex] + '</div>';
					}
				}

				var aktuality = document.querySelectorAll('.js-aktuality');
				for (var i = 0; i < aktuality.length; i++) {
					aktuality[i].innerHTML = output;
				}
			} else {
				var aktuality = document.querySelectorAll('.js-aktuality');
				for (var i = 0; i < aktuality.length; i++) {
					aktuality[i].style.display = 'none';
				}
			}
		}
	}
);
